import { render, staticRenderFns } from "./RightLowerBarNavButtons.vue?vue&type=template&id=05ccc213&scoped=true&"
import script from "./RightLowerBarNavButtons.vue?vue&type=script&lang=js&"
export * from "./RightLowerBarNavButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ccc213",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ccc213')) {
      api.createRecord('05ccc213', component.options)
    } else {
      api.reload('05ccc213', component.options)
    }
    module.hot.accept("./RightLowerBarNavButtons.vue?vue&type=template&id=05ccc213&scoped=true&", function () {
      api.rerender('05ccc213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarRightSide/RightLowerBarNavButtons.vue"
export default component.exports